export const RECORDER_EXTENSION_ID = 'chromeExtensionId';
export const RESTREAMER_EXTENSION_ID = 'restreamerExtensionId';
